import React, {useEffect, useRef} from 'react'
import ko from 'knockout'
import 'devexpress-reporting/dx-webdocumentviewer'
import '../../node_modules/devextreme/dist/css/dx.light.css'
import '../../node_modules/devexpress-reporting/dist/css/dx-webdocumentviewer.css'
import '../../node_modules/@devexpress/analytics-core/dist/css/dx-analytics.common.css'
import '../../node_modules/@devexpress/analytics-core/dist/css/dx-analytics.light.css'
import {DxReportViewer} from 'devexpress-reporting/dx-webdocumentviewer'
import {BASE_URL} from '../url.ts'

const ReportViewer = (props) => {
  // const {tenant} = useAuth()
  const reportUrl = ko.observable(`${props.reportName}`)
  const viewerRef = useRef()
  const requestOptions = {
    host: `${BASE_URL}/productionreport/`,
    invokeAction: 'DXXRDV',
  }

  useEffect(() => {
    const viewer = new DxReportViewer(viewerRef.current, {
      reportUrl,
      requestOptions,
    })
    viewer.render()
    return () => viewer.dispose()
  })
  return <div ref={viewerRef}></div>
}
function CommonReportComponent(props) {
  return (
    <div style={{width: '100%', height: '1000px'}}>
      <ReportViewer reportName={props.reportName} />
    </div>
  )
}

export default CommonReportComponent
